import { DEFAULT_SETTINGS, type AppSettings } from "../core/types";
import { idbGet, idbPut } from "./idb";

const KEY = "settings";

export async function loadSettings(): Promise<AppSettings> {
  const stored = await idbGet<Partial<AppSettings>>("meta", KEY);
  if (!stored) return { ...DEFAULT_SETTINGS, pip: { ...DEFAULT_SETTINGS.pip } };
  return {
    ...DEFAULT_SETTINGS,
    ...stored,
    quality: { ...DEFAULT_SETTINGS.quality, ...(stored.quality ?? {}) },
    pip: { ...DEFAULT_SETTINGS.pip, ...(stored.pip ?? {}) },
  };
}

export async function saveSettings(settings: AppSettings): Promise<void> {
  await idbPut("meta", KEY, settings);
}

const darkQuery = window.matchMedia("(prefers-color-scheme: dark)");
let currentTheme: AppSettings["theme"] = "auto";

darkQuery.addEventListener("change", () => {
  if (currentTheme === "auto") applyTheme("auto");
});

/** "auto" is resolved here, so the stylesheet needs no duplicated media block. */
export function applyTheme(theme: AppSettings["theme"]): void {
  currentTheme = theme;
  const resolved = theme === "auto" ? (darkQuery.matches ? "dark" : "light") : theme;
  document.documentElement.setAttribute("data-theme", resolved);
}
